<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :disabled="devices.length > 0"
        v-bind="attrs"
        v-on="on"
        class="mr-2"
        small
        color="primary"
      >
        <v-icon small left>mdi-plus-circle-outline</v-icon>
        {{ $t("importModal.importDevicesBtn") }}
      </v-btn>
    </template>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title class="headline">
          {{ $t("importModal.importDevices") }}
        </v-card-title>

        <v-card-text>
          <v-text-field
            label="Firebase Host URL"
            v-model="firebaseHOST"
            :rules="rules"
            type="text"
            required
            color="primary"
          />
          <v-text-field
            label="Secret"
            v-model="firebaseSecret"
            :rules="rules"
            type="text"
            required
            color="primary"
          />

          <!-- <v-row>
            <v-col cols="6">
              <v-switch v-model="remember" label="Remember me"></v-switch>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mt-5"
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <p class="mb-1 text-center">
                  Credentials are saved locally on your browser.
                  <br />
                  ~
                  <br />
                  We do not store this data.
                </p>
              </v-tooltip></v-col
            >
          </v-row> -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="btnLoading"
            :disabled="!firebaseHOST || !valid || btnLoading"
            color="primary"
            depressed
            outlined
            @click="getDevices"
          >
            {{ $t("import") }}
          </v-btn>
          <v-btn color="primary" text @click="dialog = false">
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: ["devices"],
  data() {
    return {
      valid: true,
      rules: [(v) => !!v || this.$i18n.t("importModal.required")],
      dialog: false,
      btnLoading: false,
      firebaseHOST: null,
      firebaseSecret: null,
    };
  },
  methods: {
    async getDevices() {
      this.btnLoading = true;
      try {
        if (this.$refs.form.validate()) {
          const payload = {
            host: this.firebaseHOST,
            secret: this.firebaseSecret,
          };

          await this.$store.dispatch("fetchAllDevices", payload);

          this.$store.dispatch("setFirebaseAuth", payload);

          this.dialog = false;
          this.btnLoading = false;
        }
        this.btnLoading = false;
      } catch {
        this.dialog = false;
      }
    },
  },
};
</script>
